import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=12e2d96c"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "./Services.vue?vue&type=style&index=0&id=12e2d96c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12e2d96c')) {
      api.createRecord('12e2d96c', component.options)
    } else {
      api.reload('12e2d96c', component.options)
    }
    module.hot.accept("./Services.vue?vue&type=template&id=12e2d96c", function () {
      api.rerender('12e2d96c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Services.vue"
export default component.exports